<ng-container *ngIf="dialog">
    <ng-container *ngTemplateOutlet="allergiesDialog"></ng-container>
</ng-container>

<ng-container *ngIf="!dialog">
    <ng-container *ngTemplateOutlet="allergiesCards" ></ng-container>
</ng-container>


<ng-template #allergiesDialog>
    <p-dialog [draggable]="false" [blockScroll]="true" [resizable]="false" [(visible)]="visible" [breakpoints]="{ '1150px': '90vw' }" [style]="{ width: '60%' }" (onHide)="onDialogHide()">
        <ng-container *ngTemplateOutlet="allergiesCards"></ng-container>
    </p-dialog>
</ng-template>

<ng-template #allergiesCards>
    <div class="mt-4 align-items-center justify-content-center w-100 text-center" *ngIf="showTitle">
        <span class="fm-prompt fw-bold" style="font-size: 1.429rem;color: #0F0F1F;">{{title}}</span>
        <br>
        <span>{{subtitle}}</span>
    </div>
    <div class="mt-3 web-center allergies-list-container p-4" style="position: relative;">
        
        <ngx-spinner name="allergies-spinner" type="ball-spin-clockwise" bdColor="rgba(249, 249, 251, 0.8)" size="small" color="#ef870a" [fullScreen]="false"></ngx-spinner>
        
        <button *ngFor="let allergy of allergies" class="btn btn-primary mt-2 mb-1 fm-rubik mx-2 sport-buttons" style="font-weight: 400;"
            (mouseenter)="mouseEnterAllergy(allergy)" (mouseleave)="mouseLeaveAllergy(allergy)"
            (click)="allergy.selected = !allergy.selected"  [style]="isMobile ? 'padding: 7px' : ''" [style]="allergy.is_hover ? 'box-shadow: 0px 0px 30px 0px #6363B14D;' : ''"
            [style.background-color]="allergy.selected ? '#DFDFEF' : 'white'">
            <div style="display: flex; align-items: center;">
                <img [src]="allergy.icon" style="width: 24px;height: 24px;margin-right: 0.8rem;" [class]="!allergy.selected && allergy.is_hover ? 'invert-color' : ''" alt="">{{allergy.name}}
                <img *ngIf="allergy.selected" src="assets/images/selectedSport.png" style="margin-left: 0.7rem;width: 21.5px;height: 21.5px;" alt="">
                <i class="pi pi-plus-circle text-white fs08 arrow-icon" style="font-size: 1.5rem;margin-left: 0.7rem;"
                    *ngIf="!allergy.selected && allergy.is_hover" [@enterAnimation]></i>
                <i class="pi pi-plus-circle text-white fs08 arrow-icon" style="font-size: 1.5rem;margin-left: 0.7rem;"
                    [hidden]="allergy.is_hover" *ngIf="!allergy.selected"></i>
            </div>
        </button>
    </div>
    <div class="mt-3 web-center">
        <app-orange-button text="Continue" (action)="saveAllergies()"></app-orange-button>
    </div>
</ng-template>